<template>
  <lu-vbox> 
    <lu-item lu-click style='padding: 5px 0; margin-left:auto; margin-right: 14px;'>
      <el-button class="button" icon="el-icon-delete" @click.stop='clearAllNotifications' >{{ $t('action.clearAll') }}</el-button>
    </lu-item>

    <lu-scroll-area lu-flex :scrollbarWidth='10' style='height: 100%; padding: 0 4px;'>
      <notificationbar-item class="notification-item" v-for="notif in activeNotificationList" :key="notif.alertId" :item="notif"/>
    </lu-scroll-area>
  </lu-vbox>
</template>

<script>
import { LuVbox, LuItem, LuScrollArea } from 'lusis-ui'
import { mapGetters, mapActions } from 'vuex'
import NotificationbarItem from './NotificationbarItem'

export default {
  components: { LuVbox, NotificationbarItem, LuItem, LuScrollArea },
  computed: {
    ...mapGetters([
      'notificationList'
    ]),
    activeNotificationList() {
      return this.notificationList.filter(notif => notif.isRead === 0)
    }
  },
  methods: {
    ...mapActions('user', [ 'setReadNotificationAll' ]),
    clearAllNotifications: function () {
      let cond = {
        functionId: 'readNotification',
        parameterList: [
          { paramName: 'id', paramValue: 'all' }
        ]
      }
      return this.$tango.getFunctionData(cond).then(rep => {
        if (rep.resultCode !== 0) throw new Error('Notifications: Clear All failed')
        else {
          this.setReadNotificationAll(1)
        }
      })
    }
  }
}
</script>
